import React from "react";
import { Link } from "react-router-dom";
import industryImg from "../images/INDUSTRY.png";

const OurCustomer = ({ partner, sliders }) => {
  return (
    <section className="bg-chinese-black text-white">
      <div className="container-fluid pt-13 pb-9">
        <div className="ms-13 me-13">
          <div className="row">
            <div className="col-lg-6 position-relative">
              <div style={{ position: "relative", zIndex: "10" }}>
                <h1 className="gilroy-bold fs-56 lh-64 text-capitalize text-center text-lg-start">
                  {partner?.heading}
                </h1>
                <p
                  className="fs-28 lh-40 pt-5 solution-description"
                  dangerouslySetInnerHTML={{ __html: partner?.description }}
                />
              </div>
              <div className="position-absolute customer-img-position">
                <img
                  src={industryImg}
                  loading="lazy"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row fs-20 lh-40 solution">
                <div className="col-12 col-md-6 col-lg-6">
                  <Link
                    to="/industry/agriculture"
                    className="text-decoration-none text-dark"
                  >
                    <p className="card-design-2">
                      {partner?.text_one || "Agriculture"}
                    </p>
                  </Link>
                  <Link
                    to="/industry/solar-alternative-energy"
                    className="text-decoration-none text-dark"
                  >
                    <p className="card-design-2">
                      {partner?.text_two || "Solar Alternative Energy"}
                    </p>
                  </Link>
                  <Link
                    to="/industry/smart-homes"
                    className="text-decoration-none text-dark"
                  >
                    <p className="card-design-2">
                      {partner?.text_three || "Smart Homes"}
                    </p>
                  </Link>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <Link
                    to="/industry/software-apps"
                    className="text-decoration-none text-dark"
                  >
                    <p className="card-design-2">
                      {partner?.text_four || "Software Apps"}
                    </p>
                  </Link>
                  <Link
                    to="/industry/digital-marketing"
                    className="text-decoration-none text-dark"
                  >
                    <p className="card-design-2">
                      {partner?.text_five || "Digital Marketing"}
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurCustomer;
